var QueryStatus;
(function (QueryStatus) {
    QueryStatus["PENDING"] = "PENDING";
    QueryStatus["SUCCESS"] = "SUCCESS";
    QueryStatus["ERROR"] = "ERROR";
})(QueryStatus || (QueryStatus = {}));

export { QueryStatus };
//# sourceMappingURL=QueryStatus.js.map
